import React from "react";
import styled from "styled-components";

const Typography = ({ children, fontSize, fontWeight, fontColor }) => {
  return (
    <StyledText
      fontSize={fontSize}
      fontWeight={fontWeight}
      fontColor={fontColor}
    >
      {children}
    </StyledText>
  );
};

const StyledText = styled.div`
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  color: ${(props) => props.fontColor};
`;

export default Typography;
